(function () {
  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function setupScrubber(section) {
    if (!section || section.dataset.vivibitMediaReady === "true") return;
    section.dataset.vivibitMediaReady = "true";

    const ticks = section.querySelector("[data-vb-ticks]");
    const playhead = section.querySelector("[data-vb-playhead]");
    const timecode = section.querySelector("[data-vb-timecode]");
    const tickCount = Number(section.dataset.tickCount || 60);
    const fps = Number(section.dataset.fps || 60);

    if (ticks && ticks.children.length === 0) {
      for (let i = 0; i < tickCount; i += 1) {
        const tick = document.createElement("span");
        tick.className = "vb-scrubber__tick";
        ticks.appendChild(tick);
      }
    }

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion || !playhead || !timecode) return;

    let frame = Number(section.dataset.startFrame || 180);
    const totalFrames = fps * 60;

    window.setInterval(function () {
      frame = (frame + 1) % totalFrames;
      const percent = (frame / totalFrames) * 100;
      playhead.style.left = percent + "%";

      const currentFrame = frame % fps;
      const seconds = Math.floor(frame / fps) % 60;
      const minute = 1 + Math.floor(frame / (fps * 60));
      timecode.textContent = "01:" + pad(minute % 100) + ":" + pad(seconds) + ":" + pad(currentFrame);
    }, 1000 / fps);
  }

  function init() {
    document.querySelectorAll("[data-vivibit-media]").forEach(setupScrubber);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:reorder", init);
})();
